// dependencies imports ⇒
import React, { useEffect, useState } from "react";
// assets and scss imports ⇒
import "./consultationDetails.scss";
import DeleteIcon from "../../../assets/delete_icon_pre.svg";
// project file imports(UI components) ⇒
import CustomSelect from "../../UI Component/CustomSelect/CustomSelect";
import ProcedureCancelledUI from "./ProcedureCancelledUI";
import CustomButton from "../../common/Buttons/CustomButton";
import CustomCheckbox from "../../common/CustomCheckbox";
import { ClickAwayListener } from "@material-ui/core";
import ArrowDown from "../../../assets/down-arrow-grey.svg";
import useIsMobile from "../../../Util/Helper/useIsMobile";

const ConsultationDetails = (props) => {
  const {
    appointmentDetails,
    procedureDetails,
    consultationOptions,
    totalConsultationFees,
    addNewProcedure,
    deleteProcedure,
    handleConsultationType,
    applyRefund,
    applyDiscount,
    applyFee,
    applyDefaultFee,
    applyDefaultDiscount,
    applyDefaultRefund,
    setAppointmentDetails,
    setProcedureDetails,
    applyBulkDiscount,
  } = props;

  const [isBulkDiscountVisible, setIsBulkDiscountVisible] = useState(false);
  const [showBulkDiscountTypeOptions, setShowBulkDiscountTypeOptions] =
    useState(false);
  const [bulkDiscountTypeValue, setBulkDiscountTypeValue] =
    useState("Percentage");
  const [bulkDiscountAmount, setBulkDiscountAmount] = useState("");
  const [bulkDiscountPercentage, setBulkDiscountPercentage] = useState("");
  const isMobile = useIsMobile();
  const [appointmentDetailsState, setAppointmentDetailsState] = useState(
    JSON.parse(JSON.stringify(appointmentDetails))
  );

  const [procedureDetailsState, setProcedureDetailsState] = useState(
    JSON.parse(JSON.stringify(procedureDetails))
  );
  const [selectedAllCheckbox, setSelectedAllCheckbox] = useState(false);
  const [totalCheckedForBulkDiscount, setTotalCheckedForBulkDiscount] =
    useState(0);
  const [totalConsultationFeesSelected, setTotalConsultationFeesSelected] =
    useState(0);
  const [totalConsultationRefundSelected, setTotalConsultationRefundSelected] =
    useState(0);

  useEffect(() => {
    handleAddCheckboxInAppointments();
    handleAddCheckboxInProcedures();
  }, [procedureDetails, appointmentDetails]);

  useEffect(() => {
    calculateTotalConsultationFees();
  }, [appointmentDetailsState, procedureDetailsState]);

  // Helper methods ⇒
  const renderConsultationType = (
    appointmentType,
    consultationType,
    procedureName
  ) => {
    let appointmentTypeText =
      appointmentType === "in-clinic" ? "In-Clinic" : "Tele-Consult";
    switch (consultationType) {
      case "regular":
        return <span>{appointmentTypeText + " Regular"}</span>;
      case "followup":
        return <span>{appointmentTypeText + " Follow-Up"}</span>;
      case "procedure":
        return <span>{procedureName}</span>;
      case "instant":
        return <span>Instant</span>;
      default:
        return "";
    }
  };

  const handleBulkDiscountValue = (e) => {
    if (bulkDiscountTypeValue === "Percentage" && e.target.value <= 100) {
      let decimalValues = e.target.value.toString().split(".")[1];
      if (decimalValues && decimalValues?.length > 2) {
        return;
      }

      const percentageValue = parseFloat(e.target.value);
      const discountAmount =
        (percentageValue / 100) * totalConsultationFeesSelected;
      if (
        discountAmount >
        totalConsultationFeesSelected - totalConsultationRefundSelected
      ) {
        alert(
          "Discount Percentage cannot be more than total consultation fees"
        );
        return;
      }
      setBulkDiscountPercentage(e.target.value != "" ? e.target.value : "");
    } else if (bulkDiscountTypeValue === "Percentage" && e.target.value > 100) {
      alert("More than 100%");
    }
    if (
      bulkDiscountTypeValue === "Amount" &&
      e.target.value <=
        totalConsultationFeesSelected - totalConsultationRefundSelected
    ) {
      let decimalValues = e.target.value.toString().split(".")[1];
      if (decimalValues && decimalValues?.length > 2) {
        return;
      }
      setBulkDiscountAmount(e.target.value != "" ? e.target.value : "");
    } else if (
      bulkDiscountTypeValue === "Amount" &&
      e.target.value >
        totalConsultationFeesSelected - totalConsultationRefundSelected
    ) {
      alert("Discount amount cannot be more than total consultation fees");
    }
  };

  const handleConvertBulkDiscountAmountToPercentage = (amount) => {
    let percentage = (amount / totalConsultationFeesSelected) * 100;
    setBulkDiscountPercentage(percentage);
  };
  const handleConvertBulkDiscountPercentageToAmount = (percentage) => {
    let amount = (percentage * totalConsultationFeesSelected) / 100;
    setBulkDiscountAmount(amount);
  };

  const displayValue = (val) => {
    let decimalValues = val.toString().split(".")[1];
    if (!decimalValues || decimalValues?.length <= 2) {
      return val;
    }
    return Number(val).toFixed(2);
  };

  const handleAddCheckboxInAppointments = () => {
    let tempAppointmentDetails = JSON.parse(JSON.stringify(appointmentDetails));

    if (tempAppointmentDetails.length > 0) {
      let isUpdateAppointmentDetails = false;
      tempAppointmentDetails.map((appointment) => {
        if (!appointment.hasOwnProperty("isBulkDiscountCheckbox")) {
          isUpdateAppointmentDetails = true;
          appointment.isBulkDiscountCheckbox = false;
          appointment.isBulkDiscountCheckboxDisabled =
            handleCheckIsBulkDiscountCheckboxDisabled(appointment);
        }
      });

      if (isUpdateAppointmentDetails) {
        setAppointmentDetails(tempAppointmentDetails);
      }
    }
    setAppointmentDetailsState(
      JSON.parse(JSON.stringify(tempAppointmentDetails))
    );
  };
  const handleCheckIsBulkDiscountCheckboxDisabled = (appointment) => {
    if (
      appointment?.partial_amount > 0 ||
      appointment?.payment_method === "online"
    ) {
      return true;
    }
    return false;
  };
  const handleAddCheckboxInProcedures = () => {
    let tempProcedureDetails = JSON.parse(JSON.stringify(procedureDetails));
    if (tempProcedureDetails.length > 0) {
      let isUpdateProcedureDetails = false;

      tempProcedureDetails.map((procedure) => {
        if (!procedure?.hasOwnProperty("isBulkDiscountCheckbox")) {
          isUpdateProcedureDetails = true;
          procedure.isBulkDiscountCheckbox = false;
          procedure.isBulkDiscountCheckboxDisabled = false;
        } else {
          procedure.isBulkDiscountCheckboxDisabled = procedure?.is_deleted;
        }
      });
      if (isUpdateProcedureDetails) {
        setProcedureDetails(tempProcedureDetails);
      }
    }
    setProcedureDetailsState(JSON.parse(JSON.stringify(tempProcedureDetails)));
  };

  const handleUpdateCheckBox = (type, index) => {
    let tempAppointmentDetails = JSON.parse(
      JSON.stringify(appointmentDetailsState)
    );
    let tempProcedureDetails = JSON.parse(
      JSON.stringify(procedureDetailsState)
    );
    if (type === "appointment") {
      tempAppointmentDetails[index].isBulkDiscountCheckbox =
        !tempAppointmentDetails[index].isBulkDiscountCheckbox;

      setAppointmentDetails(tempAppointmentDetails);
      setAppointmentDetailsState(tempAppointmentDetails);
    }
    if (type === "procedure") {
      tempProcedureDetails[index].isBulkDiscountCheckbox =
        !tempProcedureDetails[index].isBulkDiscountCheckbox;

      setProcedureDetails(tempProcedureDetails);
      setProcedureDetailsState(tempProcedureDetails);
    }
    handleCountSelectedCheckboxForBulkDiscount(
      tempAppointmentDetails,
      tempProcedureDetails
    );
  };

  const handleSelectAllCheckboxForBulkDiscount = () => {
    let tempAppointmentDetails = JSON.parse(
      JSON.stringify(appointmentDetailsState)
    );
    let tempProcedureDetails = JSON.parse(
      JSON.stringify(procedureDetailsState)
    );
    let totalChecked = 0;
    tempAppointmentDetails.map((appointment) => {
      if (!appointment.isBulkDiscountCheckboxDisabled) {
        appointment.isBulkDiscountCheckbox = !selectedAllCheckbox;
        if (!selectedAllCheckbox === true) {
          totalChecked++;
        }
      }
    });
    tempProcedureDetails.map((procedure) => {
      if (!procedure.isBulkDiscountCheckboxDisabled) {
        procedure.isBulkDiscountCheckbox = !selectedAllCheckbox;
        if (!selectedAllCheckbox === true) {
          totalChecked++;
        }
      }
    });
    setTotalCheckedForBulkDiscount(totalChecked);
    setSelectedAllCheckbox(totalChecked > 0);
    setAppointmentDetails(tempAppointmentDetails);
    setAppointmentDetailsState(tempAppointmentDetails);
    setProcedureDetails(tempProcedureDetails);
    setProcedureDetailsState(tempProcedureDetails);
  };

  const handleCountSelectedCheckboxForBulkDiscount = (
    appointments,
    procedures
  ) => {
    let totalChecked =
      appointments.reduce(
        (acc, item) => acc + (item.isBulkDiscountCheckbox ? 1 : 0),
        0
      ) +
      procedures.reduce(
        (acc, item) => acc + (item.isBulkDiscountCheckbox ? 1 : 0),
        0
      );
    setTotalCheckedForBulkDiscount(totalChecked);
    appointments.length + procedures.length === totalChecked
      ? setSelectedAllCheckbox(true)
      : setSelectedAllCheckbox(false);
  };

  const handleApplyDefaultDiscount = (e, index, isAmount) => {
    let tempAppointmentDetails = JSON.parse(
      JSON.stringify(appointmentDetailsState)
    );
    if (isAmount) {
      let discountAmount = Number(e.target.value);
      tempAppointmentDetails[index].discount_amount = discountAmount;

      let discountPercentage =
        Math.round(
          ((discountAmount * 100) /
            tempAppointmentDetails[index]?.fee_in_rupees) *
            100
        ) / 100;
      applyDefaultDiscount(
        { target: { value: discountPercentage } },
        index,
        tempAppointmentDetails
      );
    } else {
      if (e.target.value <= 100 && e.target.value >= 0) {
        let discountPercentage = e.target.value;
        tempAppointmentDetails[index].discount_percent = discountPercentage;
        tempAppointmentDetails[index].discount_amount =
          (tempAppointmentDetails[index]?.fee_in_rupees * discountPercentage) /
          100;
        applyDefaultDiscount(e, index, tempAppointmentDetails);
      }
    }
  };

  const handleApplyDiscount = (e, index, isAmount) => {
    let tempProcedureDetails = JSON.parse(
      JSON.stringify(procedureDetailsState)
    );
    if (isAmount) {
      tempProcedureDetails[index].discount_amount = e.target.value;
      let discountPercentage =
        (e.target.value * 100) / tempProcedureDetails[index]?.fee_in_rupees;
      tempProcedureDetails[index].discount_percent = discountPercentage;
      applyDiscount(
        {
          ...e,
          target: {
            ...e.target,
            value: discountPercentage,
          },
        },
        index,
        tempProcedureDetails
      );
    } else {
      tempProcedureDetails[index].discount_amount =
        (tempProcedureDetails[index]?.fee_in_rupees * e.target.value) / 100;
      applyDiscount(e, index, tempProcedureDetails);
    }
  };

  const handleApplyBulkDiscount = () => {
    let discountValue =
      bulkDiscountTypeValue === "Amount"
        ? bulkDiscountAmount
        : bulkDiscountPercentage;
    applyBulkDiscount(
      bulkDiscountTypeValue,
      discountValue,
      totalConsultationFeesSelected
    );
    setBulkDiscountAmount("");
    setBulkDiscountPercentage("");
    setTotalCheckedForBulkDiscount(0);
    setSelectedAllCheckbox(false);
  };

  const calculateTotalConsultationFees = () => {
    let totalFees = 0;
    let totalRefundFee = 0;

    appointmentDetailsState.forEach((appointment) => {
      if (appointment.isBulkDiscountCheckbox) {
        totalFees += appointment.fee_in_rupees;
        totalRefundFee += appointment.refund_in_rupees;
      }
    });
    procedureDetailsState.forEach((procedure) => {
      if (procedure.isBulkDiscountCheckbox) {
        totalFees += procedure.fee_in_rupees;
        totalRefundFee += procedure.refund_in_rupees;
      }
    });
    setTotalConsultationFeesSelected(totalFees);
    setTotalConsultationRefundSelected(totalRefundFee);
  };

  // create UI ⇒

  const displayAppointmentRowDiscountAmountInput = (appointment, index) => {
    return (
      <div className="cd-discount-amt-container">
        <span>₹</span>
        <input
          type="number"
          onKeyDown={(e) => {
            (e.key?.toLowerCase() === "e" || e.key === "+" || e.key === "-") &&
              e.preventDefault();
          }}
          max={appointment.fee_in_rupees}
          className="cd-amount-input"
          value={displayValue(appointment.discount_amount)}
          placeholder="0"
          onChange={(e) => {
            if (Number(e.target.value) <= appointment.fee_in_rupees) {
              let decimalValues = e.target.value.toString().split(".")[1];
              if (decimalValues && decimalValues?.length > 2) {
                return;
              }
              handleApplyDefaultDiscount(e, index, true);
            } else {
              alert("Discount amount cannot be more than consultation fee");
            }
          }}
          autoComplete="off"
          disabled={appointment.is_deleted}
        />
      </div>
    );
  };
  const displayAppointmentRowDiscountPercentageInput = (appointment, index) => {
    return (
      <div className="cd-discount-amt-container cd-discount-percentage-container">
        <input
          type="number"
          maxLength="3"
          min="0"
          max="100"
          onKeyDown={(e) => {
            (e.key?.toLowerCase() === "e" || e.key === "+" || e.key === "-") &&
              e.preventDefault();
          }}
          className="cd-amount-input"
          value={displayValue(appointment.discount_percent)}
          placeholder="0"
          onChange={(e) => {
            if (e.target.value <= 100 && e.target.value >= 0) {
              let decimalValues = e.target.value.toString().split(".")[1];
              if (decimalValues && decimalValues?.length > 2) {
                return;
              }
              handleApplyDefaultDiscount(e, index, false);
            } else {
              alert("More than 100%");
            }
          }}
          autoComplete="off"
          disabled={appointment.is_deleted}
        />
        <span>%</span>
      </div>
    );
  };

  const displayProcedureRowDiscountAmountInput = (procedurePerRow, index) => {
    return (
      <div className="cd-discount-amt-container">
        <span>₹</span>
        <input
          type="number"
          maxLength="4"
          min="0"
          max="100"
          onKeyDown={(e) => {
            (e.key?.toLowerCase() === "e" || e.key === "+" || e.key === "-") &&
              e.preventDefault();
          }}
          className="cd-amount-input"
          column={index + 1}
          value={
            procedurePerRow?.discount_amount === null
              ? "0"
              : displayValue(procedurePerRow.discount_amount)
          }
          index={index}
          placeholder="0"
          onChange={(e) => {
            let inputValue = e.target.value;
            if (inputValue === "") {
              handleApplyDiscount(
                { ...e, target: { ...e.target, value: 0 } },
                index,
                true
              );
              return;
            }
            const regex = /^\d*\.?\d{0,2}$/;
            if (!regex.test(inputValue)) return;
            if (!inputValue.includes(".") && /^0\d+/.test(inputValue)) {
              inputValue = inputValue.replace(/^0+/, "");
            }
            const value = Number(inputValue);
            if (value <= procedurePerRow.fee_in_rupees) {
              handleApplyDiscount(
                { ...e, target: { ...e.target, value: inputValue } },
                index,
                true
              );
            } else {
              alert("Discount amount cannot be more than consultation fee");
            }
          }}
          autoComplete="off"
          disabled={procedurePerRow.is_deleted}
        />
      </div>
    );
  };
  const displayProcedureRowDiscountPercentageInput = (
    procedurePerRow,
    index
  ) => {
    return (
      <div className="cd-discount-amt-container cd-discount-percentage-container">
        <input
          type="number"
          maxLength="4"
          min="0"
          max="100"
          onKeyDown={(e) => {
            (e.key?.toLowerCase() === "e" || e.key === "+" || e.key === "-") &&
              e.preventDefault();
          }}
          className="cd-amount-input"
          column={index + 1}
          value={
            procedurePerRow?.discount_percent == null
              ? 0
              : displayValue(procedurePerRow.discount_percent)
          }
          index={index}
          placeholder="0"
          onChange={(e) => {
            if (e.target.value <= 100 && e.target.value >= 0) {
              let decimalValues = e.target.value.toString().split(".")[1];
              if (decimalValues && decimalValues?.length > 2) {
                return;
              }
              handleApplyDiscount(e, index, false);
            } else {
              alert("More than 100%");
            }
          }}
          autoComplete="off"
          disabled={procedurePerRow.is_deleted}
        />
        <span>%</span>
      </div>
    );
  };

  const displayCancelledText = () => {
    return <ProcedureCancelledUI />;
  };
  const getConsultationLabel = (procedurePerRow) => {
    const procedureName = procedurePerRow.procedure_name;
    const consultationName = procedurePerRow.consultation_name;

    let labelToFind = "";

    if (procedureName) {
      if (procedureName.includes("followup")) {
        labelToFind = "In-clinic Follow-up";
      } else if (procedureName.includes("regular")) {
        labelToFind = "In-clinic Regular";
      } else {
        labelToFind = procedureName;
      }
    } else if (consultationName) {
      if (consultationName.includes("followup")) {
        labelToFind = "In-clinic Follow-up";
      } else if (consultationName.includes("regular")) {
        labelToFind = "In-clinic Regular";
      }
    }

    return labelToFind;
  };

  const getConsultationValue = (procedurePerRow) => {
    const labelToFind = getConsultationLabel(procedurePerRow);
    return consultationOptions.find((option) => option.label === labelToFind);
  };
  const displaybulkDiscountUI = () => {
    return (
      <div className="consultation-details-bulk-discount-container">
        <div className="cdbdc-text">{`Set Discount for (${totalCheckedForBulkDiscount}) Selected Rows`}</div>
        <div className="cdbdc-input-container">
          <div>
            <input
              type="number"
              min="0"
              onKeyDown={(e) => {
                (e.key?.toLowerCase() === "e" ||
                  e.key === "+" ||
                  e.key === "-") &&
                  e.preventDefault();
              }}
              className="cdbdc-input"
              placeholder={
                bulkDiscountTypeValue === "Amount"
                  ? "Enter Amount"
                  : "Enter Percentage"
              }
              value={
                bulkDiscountTypeValue === "Amount"
                  ? displayValue(bulkDiscountAmount)
                  : displayValue(bulkDiscountPercentage)
              }
              onChange={(e) => {
                handleBulkDiscountValue(e);
              }}
            />
          </div>
          <div style={{ position: "relative" }}>
            <div
              className="cdbdc-discount-type-input"
              onClick={() => {
                setShowBulkDiscountTypeOptions(!showBulkDiscountTypeOptions);
              }}
            >
              <span>{bulkDiscountTypeValue === "Amount" ? "₹" : "%"}</span>
              {<img src={ArrowDown} alt="" />}
            </div>
            {showBulkDiscountTypeOptions && (
              <ClickAwayListener
                onClickAway={() => setShowBulkDiscountTypeOptions(false)}
              >
                <div className="cdbdc-discount-type-options">
                  <div
                    onClick={() => {
                      setBulkDiscountTypeValue("Amount");
                      setShowBulkDiscountTypeOptions(false);
                      handleConvertBulkDiscountPercentageToAmount(
                        bulkDiscountPercentage
                      );
                    }}
                  >
                    Amount
                  </div>
                  <div
                    onClick={() => {
                      setBulkDiscountTypeValue("Percentage");
                      setShowBulkDiscountTypeOptions(false);
                      handleConvertBulkDiscountAmountToPercentage(
                        bulkDiscountAmount
                      );
                    }}
                  >
                    Percentage
                  </div>
                </div>
              </ClickAwayListener>
            )}
          </div>
        </div>
        <div className="cdbdc-action-btns">
          <div>
            <CustomButton
              title={"Update"}
              disabled={
                totalCheckedForBulkDiscount === 0 ||
                (bulkDiscountTypeValue === "Amount" &&
                  bulkDiscountAmount === "") ||
                (bulkDiscountTypeValue === "Percentage" &&
                  bulkDiscountPercentage === "") ||
                bulkDiscountAmount > totalConsultationFeesSelected
              }
              handleButtonClick={handleApplyBulkDiscount}
              variant={"primary"}
            />
          </div>
          <div>
            <CustomButton
              title={"Cancel"}
              disabled={false}
              handleButtonClick={() => {
                setIsBulkDiscountVisible(false);
                setBulkDiscountAmount("");
                setBulkDiscountPercentage("");
              }}
              variant={"secondary"}
            />
          </div>
        </div>
      </div>
    );
  };

  const displayApplyBulkDiscountCTA = () => {
    return (
      <CustomButton
        title={"Apply Bulk Discount"}
        disabled={totalCheckedForBulkDiscount === 0}
        handleButtonClick={() => setIsBulkDiscountVisible(true)}
        variant={"primary"}
      />
    );
  };

  const consulationDetailsUI = () => {
    return (
      <div className="consultation-details-container">
        <div className="row info m-0 mb-2">
          <div className="consultation-details-btn-cont">
            CONSULTATION DETAILS
            <div className="consultation-details-btn">
              {!isBulkDiscountVisible && displayApplyBulkDiscountCTA()}
            </div>
            <div className="consultation-details-btn-mobile">
              {displayApplyBulkDiscountCTA()}
            </div>
            <div className="cdbdc-web">
              {isBulkDiscountVisible && displaybulkDiscountUI()}
            </div>
          </div>
          {isBulkDiscountVisible && (
            <div className="cdbdc-mobile">{displaybulkDiscountUI()}</div>
          )}

          <div className="col-12 mb-2 accordian_css_mobile">
            <div id="accordion" className="col-12 accordion p-0">
              {appointmentDetailsState?.map((appointment, index) => (
                <div key={index} style={{ display: "flex" }}>
                  <CustomCheckbox
                    selected={appointment.isBulkDiscountCheckbox}
                    isDisabled={appointment.isBulkDiscountCheckboxDisabled}
                    handleOnSelect={() => {
                      handleUpdateCheckBox("appointment", index);
                    }}
                  />

                  <div className="card-container">
                    <div
                      className={`card-header ${
                        procedureDetails.length <= 1 ? "" : "collapsed"
                      }`}
                      data-toggle="collapse"
                      href={`#in_clinic_regular_${index}`}
                    >
                      <span className="circle_plus_minus"></span>
                      {appointment.payment_method ===
                      "Paid at Clinic - By Cash" ? (
                        <div style={{ width: "calc(100% - 50px)" }}>
                          <p className="cc-procedure-title">Procedure</p>
                          <div
                            className="default_procedure"
                            style={{ marginRight: "20px", marginLeft: "6px" }}
                          >
                            <span
                              className="card-title"
                              style={{
                                padding: "2px 8px",
                                width: "80%",
                                color: "rgba(0, 0, 0, 0.6)",
                              }}
                            >
                              {renderConsultationType(
                                appointment.appointment_type,
                                appointment.consultation_type,
                                appointment.procedure_name
                              )}
                            </span>
                            <div className="separator">
                              <span className="react-select__indicator-separator css-1okebmr-indicatorSeparator"></span>
                              <div
                                class="react-select__indicator react-select__dropdown-indicator css-tlfecz-indicatorContainer"
                                aria-hidden="true"
                                style={{
                                  padding: "5px",
                                  paddingLeft: "10px",
                                }}
                              >
                                <i
                                  className="fa fa-caret-down"
                                  style={{ color: "hsl(0, 0%, 70%)" }}
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <p className="cc-procedure-header">Procedure</p>
                          <a className="card-title">
                            {renderConsultationType(
                              appointment.appointment_type,
                              appointment.consultation_type,
                              appointment.procedure_name
                            )}
                          </a>
                        </div>
                      )}
                    </div>
                    <div
                      id={`in_clinic_regular_${index}`}
                      className={`card-body collapse ${
                        procedureDetails.length <= 1 ? "show" : ""
                      }`}
                      data-parent="#accordion"
                    >
                      <div className="tab_content_top">
                        <div className="consultion_header">
                          <div className="col_item w-20">Fee</div>
                          <div className="col_item w-20">Partial Fee</div>
                          <div className="col_item w-20">Subtotal</div>
                          <div className="col_item w-40">Discount</div>
                        </div>
                        <div className="consultation-details-value-container d-flex ai-center">
                          <div
                            className={
                              "col_item w-20 " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            {appointment.payment_method ===
                            "Paid at Clinic - By Cash" ? (
                              <input
                                type="tell"
                                min="0"
                                max="100"
                                onKeyPress={(event) => {
                                  if (!/\d/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                className="discount_input"
                                value={appointment.fee_in_rupees}
                                placeholder="0"
                                onChange={(e) => applyDefaultFee(e, index)}
                                autoComplete="off"
                                disabled={appointment.is_deleted}
                              />
                            ) : (
                              <div>
                                <span>₹</span>
                                {appointment?.fee_in_rupees == null
                                  ? 0
                                  : appointment.fee_in_rupees}
                              </div>
                            )}
                          </div>
                          <div
                            className={
                              "col_item w-20 " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            {appointment?.partial_with_convenience_fee ==
                            null ? (
                              0
                            ) : (
                              <span>
                                {appointment?.partial_with_convenience_fee ?? 0}
                              </span>
                            )}
                          </div>

                          <div
                            className={
                              "col_item font_weight_500 w-20 " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            <span>₹</span>
                            {appointment?.subtotal_in_rupees == null
                              ? 0
                              : appointment.subtotal_in_rupees}
                          </div>

                          <div
                            className={
                              "col_item w-40 " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            {appointment.payment_method ===
                            "Paid at Clinic - By Cash" ? (
                              <div className="cd-discount-amt-wrapper">
                                {displayAppointmentRowDiscountPercentageInput(
                                  appointment,
                                  index
                                )}

                                {displayAppointmentRowDiscountAmountInput(
                                  appointment,
                                  index
                                )}
                              </div>
                            ) : (
                              <div>
                                <span>
                                  {appointment?.discount_percent == null
                                    ? 0 + "% "
                                    : appointment.discount_percent + "% "}
                                </span>
                                <span>
                                  {appointment?.discount_amount == null
                                    ? " ₹" + 0
                                    : " ₹" + appointment.discount_amount}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="tab_content_middle">
                        <div className="consultion_header">
                          <div className="col_item">Refund</div>
                          <div className="col_item">IGST</div>
                          <div className="col_item">CGST</div>
                          <div className="col_item">SGST</div>
                        </div>
                        <div className="consultation-details-value-container d-flex ai-center">
                          <div
                            className={
                              "col_item " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            {appointment.payment_method ===
                            "Paid at Clinic - By Cash" ? (
                              <input
                                type="tell"
                                min="0"
                                max="100"
                                onKeyPress={(event) => {
                                  if (!/\d/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                className="discount_input"
                                value={appointment.refund_in_rupees}
                                placeholder="0"
                                onChange={(e) => applyDefaultRefund(e, index)}
                                autoComplete="off"
                                disabled={appointment.is_deleted}
                              />
                            ) : (
                              appointment.refund_in_rupees
                            )}
                          </div>
                          <div
                            className={
                              "col_item " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            {appointment?.igst_percent == null ? (
                              0
                            ) : (
                              <span>
                                {appointment.igst_percent}
                                {appointment.igst_percent ? "%" : ""}
                              </span>
                            )}
                          </div>
                          <div
                            className={
                              "col_item " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            {appointment?.cgst_percent == null ? (
                              0
                            ) : (
                              <span>
                                {appointment.cgst_percent}
                                {appointment.cgst_percent ? "%" : ""}
                              </span>
                            )}
                          </div>
                          <div
                            className={
                              "col_item font_weight_500 " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            {appointment?.sgst_percent == null ? (
                              0
                            ) : (
                              <span>
                                {appointment.sgst_percent}
                                {appointment.sgst_percent ? "%" : ""}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="tab_content_middle">
                        <div className="consultion_header">
                          <div className="col_item">Final Amount</div>
                          <div className="col_item">Paid</div>
                          <div className="col_item">Pending</div>
                        </div>
                        <div className="consultation-details-value-container d-flex ai-center">
                          <div
                            className={
                              "col_item total_amount_css font_weight_500 " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            <span>₹</span>
                            {appointment.final_amount_in_rupees}
                          </div>
                          <div
                            className={
                              "col_item total_amount_css font_weight_500 " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            <span>₹</span>
                            {appointment?.paid_amount
                              ? appointment?.paid_amount
                              : 0}
                          </div>
                          <div
                            className={
                              "col_item total_amount_css font_weight_500 " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            <span>₹</span>
                            {appointment?.pending_amount
                              ? appointment?.pending_amount
                              : 0}
                          </div>
                        </div>
                      </div>
                      <div className="tab_content_bottom">
                        <div className="consultion_header">
                          <div className="col_item">Total</div>
                        </div>
                        <div className="consultation-details-value-container d-flex ai-center">
                          <div
                            className={
                              "col_item font_weight_500 " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            <span>₹</span>
                            {appointment.total_fee_in_rupees}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {appointment.is_deleted && displayCancelledText()}
                </div>
              ))}
              {procedureDetailsState?.map((procedurePerRow, index) => {
                if (procedurePerRow) {
                  return (
                    <div key={index} style={{ display: "flex" }}>
                      <CustomCheckbox
                        selected={procedurePerRow.isBulkDiscountCheckbox}
                        isDisabled={
                          procedurePerRow.isBulkDiscountCheckboxDisabled
                        }
                        handleOnSelect={() => {
                          handleUpdateCheckBox("procedure", index);
                        }}
                      />
                      <div className="card-container">
                        <div
                          className="card-header"
                          data-toggle="collapse"
                          data-parent="#accordion"
                          href={`#slected_procedure_${index}`}
                        >
                          <span className="circle_plus_minus"></span>
                          <div className="cc-card-select">
                            <p className="cc-procedure-title">Procedure</p>
                            <a
                              className="card-title"
                              style={{
                                paddingRight: "20px",
                                marginLeft: "6px",
                              }}
                            >
                              <CustomSelect
                                className="select_style"
                                showSearch={true}
                                placeholder=""
                                value={consultationOptions.filter((option) => {
                                  return (
                                    option.label ===
                                    (procedurePerRow.procedure_name
                                      ? procedurePerRow.procedure_name.includes(
                                          "followup"
                                        )
                                        ? "In-clinic Follow-up"
                                        : procedurePerRow.procedure_name.includes(
                                            "regular"
                                          )
                                        ? "In-clinic Regular"
                                        : procedurePerRow.procedure_name
                                      : procedurePerRow.consultation_name.includes(
                                          "followup"
                                        )
                                      ? "In-clinic Follow-up"
                                      : procedurePerRow.consultation_name.includes(
                                          "regular"
                                        )
                                      ? "In-clinic Regular"
                                      : "")
                                  );
                                })}
                                options={consultationOptions}
                                handleChange={(opt) =>
                                  handleConsultationType(opt, index)
                                }
                                fixedBottomBtn={false}
                                isSearchable={false}
                                isDisabled={procedurePerRow.is_deleted}
                              />
                            </a>
                          </div>
                          {!procedurePerRow.is_deleted && (
                            <span
                              onClick={() => deleteProcedure(index)}
                              style={{
                                cursor: "pointer",
                                marginTop: "auto",
                                marginBottom: "8px",
                              }}
                            >
                              <img src={DeleteIcon} alt="" />
                            </span>
                          )}
                        </div>
                        <div
                          id={`slected_procedure_${index}`}
                          className="card-body collapse show"
                          data-parent="#accordion"
                        >
                          <div className="tab_content_top">
                            <div className="consultion_header">
                              <div className="col_item w-30">Fee</div>
                              <div className="col_item  w-30">Subtotal</div>
                              <div className="col_item w-40">Discount</div>
                            </div>
                            <div className="consultation-details-value-container d-flex ai-center">
                              <div
                                className={
                                  "col_item w-30 " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                {procedurePerRow.consultation_name === "" ? (
                                  0
                                ) : (
                                  <input
                                    type="tell"
                                    min="0"
                                    max="100"
                                    onKeyPress={(event) => {
                                      if (!/\d/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    className="discount_input"
                                    column={index + 1}
                                    value={procedurePerRow.fee_in_rupees}
                                    index={index}
                                    placeholder="0"
                                    onChange={(e) => applyFee(e, index)}
                                    autoComplete="off"
                                    disabled={procedurePerRow.is_deleted}
                                  />
                                )}
                              </div>
                              <div
                                className={
                                  "col_item font_weight_500 w-30" +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                <span>₹</span>
                                {procedurePerRow.subtotal_in_rupees
                                  ? procedurePerRow.subtotal_in_rupees
                                  : 0}
                              </div>
                              <div
                                className={
                                  "col_item w-40 " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                                key={index}
                              >
                                {procedurePerRow.consultation_name === "" ? (
                                  <div className="cdp-discount-amt-wrapper">
                                    <span> 0 </span>
                                    <span> 0 </span>
                                  </div>
                                ) : (
                                  <div className="cd-discount-amt-wrapper">
                                    {displayProcedureRowDiscountPercentageInput(
                                      procedurePerRow,
                                      index
                                    )}

                                    {displayProcedureRowDiscountAmountInput(
                                      procedurePerRow,
                                      index
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="tab_content_middle">
                            <div className="consultion_header">
                              <div className="col_item">Refund</div>
                              <div className="col_item">IGST</div>
                              <div className="col_item">CGST</div>
                              <div className="col_item">SGST</div>
                            </div>
                            <div className="consultation-details-value-container d-flex ai-center">
                              <div
                                className={
                                  "col_item " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                {procedurePerRow.consultation_name === "" ? (
                                  0
                                ) : (
                                  <input
                                    type="tell"
                                    min="0"
                                    max="100"
                                    onKeyPress={(event) => {
                                      if (!/\d/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    className="discount_input"
                                    column={index + 1}
                                    value={
                                      procedurePerRow?.refund_in_rupees == null
                                        ? 0
                                        : procedurePerRow.refund_in_rupees
                                    }
                                    index={index}
                                    placeholder="0"
                                    onChange={(e) => applyRefund(e, index)}
                                    autoComplete="off"
                                    disabled={procedurePerRow.is_deleted}
                                  />
                                )}
                              </div>
                              <div
                                className={
                                  "col_item " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                {procedurePerRow.igst_percent}
                                {procedurePerRow.igst_percent &&
                                procedurePerRow.igst_percent !== 0 ? (
                                  <span>%</span>
                                ) : null}
                              </div>
                              <div
                                className={
                                  "col_item " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                {procedurePerRow.cgst_percent}
                                {procedurePerRow.cgst_percent &&
                                procedurePerRow.cgst_percent !== 0 ? (
                                  <span>%</span>
                                ) : null}
                              </div>
                              <div
                                className={
                                  "col_item font_weight_500 " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                {procedurePerRow.sgst_percent}
                                {procedurePerRow.sgst_percent &&
                                procedurePerRow.sgst_percent !== 0 ? (
                                  <span>%</span>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="tab_content_middle">
                            <div className="consultion_header">
                              <div className="col_item">Final Amount</div>
                              <div className="col_item">Paid</div>
                              <div className="col_item">Pending</div>
                            </div>
                            <div className="consultation-details-value-container d-flex ai-center">
                              <div
                                className={
                                  "col_item total_amount_css font_weight_500 " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                <span>₹</span>
                                {procedurePerRow.final_amount_in_rupees
                                  ? procedurePerRow.final_amount_in_rupees
                                  : 0}
                              </div>
                              <div
                                className={
                                  "col_item font_weight_500" +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                <span>₹</span>
                                {procedurePerRow?.paid_amount
                                  ? procedurePerRow?.paid_amount
                                  : 0}
                              </div>
                              <div
                                className={
                                  "col_item total_amount_css font_weight_500 " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                <span>₹</span>
                                {procedurePerRow?.pending_amount
                                  ? procedurePerRow?.pending_amount
                                  : 0}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {procedurePerRow.is_deleted && displayCancelledText()}
                    </div>
                  );
                }
              })}
            </div>
            <div className="add-procedure-wrapper">
              <span className="add-procedure-btn" onClick={addNewProcedure}>
                + Add Procedure
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const consultationDetailsTableUI = () => {
    return (
      <div>
        <table className="consultation-details-container">
          <thead>
            <tr className="info m-0 mb-2">
              <th colSpan="12" className="consultation-details-btn-cont">
                <div className="consultation-details-btn-cont">
                  CONSULTATION DETAILS
                  <div className="consultation-details-btn">
                    {!isBulkDiscountVisible && displayApplyBulkDiscountCTA()}
                  </div>
                  <div className="consultation-details-btn-mobile">
                    {displayApplyBulkDiscountCTA()}
                  </div>
                  <div className="cdbdc-web">
                    {isBulkDiscountVisible && displaybulkDiscountUI()}
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="col-12 mb-2 consultation-details-table">
              <td colSpan="12">
                <table className="consultion-header">
                  <thead>
                    <tr>
                      <th className="cd-checkbox-wrapper">
                        <CustomCheckbox
                          selected={selectedAllCheckbox}
                          handleOnSelect={() => {
                            handleSelectAllCheckboxForBulkDiscount();
                          }}
                        />
                      </th>
                      <th className="col_item consultion_heading_name cd-border-left">
                        Procedure
                      </th>
                      <th className="col_item">Fee</th>
                      <th className="col_item" style={{ minWidth: "90px" }}>
                        Partial Fee
                      </th>
                      <th className="col_item" style={{ minWidth: "70px" }}>
                        Subtotal
                      </th>
                      <th className="col_item" style={{ minWidth: "122px" }}>
                        Discount
                      </th>
                      <th className="col_item">Refund</th>
                      <th className="col_item">IGST</th>
                      <th className="col_item">CGST</th>
                      <th className="col_item">SGST</th>
                      <th className="col_item" style={{ minWidth: "92px" }}>
                        Final Amount
                      </th>
                      <th className="col_item">Paid</th>
                      <th className="col_item">Pending</th>
                    </tr>
                  </thead>
                  <tbody>
                    {appointmentDetailsState?.map((appointment, index) => (
                      <tr
                        className="consultation-details-value-container"
                        key={index}
                      >
                        <td className="cd-checkbox-wrapper">
                          <CustomCheckbox
                            selected={appointment.isBulkDiscountCheckbox}
                            isDisabled={
                              appointment.isBulkDiscountCheckboxDisabled
                            }
                            handleOnSelect={() => {
                              handleUpdateCheckBox("appointment", index);
                            }}
                          />
                        </td>
                        <td
                          className="col_item consultion_heading_name select_style"
                          style={{
                            paddingRight: "20px",
                            paddingBottom: "0",
                            paddingTop: "0",
                          }}
                        >
                          {appointment.payment_method ===
                          "Paid at Clinic - By Cash" ? (
                            <div className="default_procedure">
                              <span
                                style={{
                                  padding: "2px 8px",
                                  width: "80%",
                                  opacity: "0.7",
                                  color: "rgb(153, 153, 153)",
                                }}
                              >
                                {renderConsultationType(
                                  appointment.appointment_type,
                                  appointment.consultation_type,
                                  appointment.procedure_name
                                )}
                              </span>
                              <div className="separator">
                                <span className="react-select__indicator-separator css-1okebmr-indicatorSeparator"></span>
                                <div
                                  className="react-select__indicator react-select__dropdown-indicator css-tlfecz-indicatorContainer"
                                  aria-hidden="true"
                                  style={{
                                    padding: "5px",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  <i
                                    className="fa fa-caret-down"
                                    style={{ color: "hsl(0, 0%, 70%)" }}
                                  ></i>
                                </div>
                              </div>
                            </div>
                          ) : (
                            renderConsultationType(
                              appointment.appointment_type,
                              appointment.consultation_type,
                              appointment.procedure_name
                            )
                          )}
                        </td>
                        <td
                          className={
                            "col_item " +
                            (appointment.is_deleted
                              ? "consultation-details-disabled"
                              : "")
                          }
                        >
                          {appointment.payment_method ===
                          "Paid at Clinic - By Cash" ? (
                            <input
                              type="tell"
                              min="0"
                              max="100"
                              onKeyPress={(event) => {
                                if (!/\d/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              className="discount_input"
                              value={appointment.fee_in_rupees}
                              placeholder="0"
                              onChange={(e) => applyDefaultFee(e, index)}
                              autoComplete="off"
                              disabled={appointment.is_deleted}
                            />
                          ) : (
                            <div>
                              <span>₹</span>
                              {appointment?.fee_in_rupees == null
                                ? 0
                                : appointment.fee_in_rupees}
                            </div>
                          )}
                        </td>
                        <td
                          className={
                            "col_item " +
                            (appointment.is_deleted
                              ? "consultation-details-disabled"
                              : "")
                          }
                          style={{ minWidth: "90px" }}
                        >
                          {appointment?.partial_with_convenience_fee == null ? (
                            0
                          ) : (
                            <span>
                              {appointment?.partial_with_convenience_fee ?? 0}
                            </span>
                          )}
                        </td>
                        <td
                          className={
                            "col_item " +
                            (appointment.is_deleted
                              ? "consultation-details-disabled"
                              : "")
                          }
                          style={{ minWidth: "70px" }}
                        >
                          <span>₹</span>
                          {appointment?.subtotal_in_rupees == null
                            ? 0
                            : appointment.subtotal_in_rupees}
                        </td>
                        <td
                          className={
                            "col_item " +
                            (appointment.is_deleted
                              ? "consultation-details-disabled"
                              : "")
                          }
                          style={{ minWidth: "122px" }}
                        >
                          {appointment.payment_method ===
                          "Paid at Clinic - By Cash" ? (
                            <div className=" cd-discount-amt-wrapper">
                              {displayAppointmentRowDiscountPercentageInput(
                                appointment,
                                index
                              )}
                              {appointment.discount_percent > 0 && (
                                <span className="cd-discount-or-text">or</span>
                              )}
                              {displayAppointmentRowDiscountAmountInput(
                                appointment,
                                index
                              )}
                            </div>
                          ) : (
                            <div>
                              <span>
                                {appointment?.discount_percent == null
                                  ? 0 + "% "
                                  : appointment.discount_percent + "% "}
                              </span>
                              <span>
                                {appointment?.discount_amount == null
                                  ? " ₹" + 0
                                  : " ₹" + appointment.discount_amount}
                              </span>
                            </div>
                          )}
                        </td>
                        <td
                          className={
                            "col_item " +
                            (appointment.is_deleted
                              ? "consultation-details-disabled"
                              : "")
                          }
                        >
                          {appointment.payment_method ===
                          "Paid at Clinic - By Cash" ? (
                            <input
                              type="tell"
                              min="0"
                              max="100"
                              onKeyPress={(event) => {
                                if (!/\d/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              className="discount_input"
                              value={appointment.refund_in_rupees}
                              placeholder="0"
                              onChange={(e) => applyDefaultRefund(e, index)}
                              autoComplete="off"
                              disabled={appointment.is_deleted}
                            />
                          ) : (
                            appointment.refund_in_rupees
                          )}
                        </td>
                        <td
                          className={
                            "col_item " +
                            (appointment.is_deleted
                              ? "consultation-details-disabled"
                              : "")
                          }
                        >
                          {appointment?.igst_percent == null ? (
                            0
                          ) : (
                            <span>
                              {appointment.igst_percent}
                              {appointment.igst_percent ? "%" : ""}
                            </span>
                          )}
                        </td>
                        <td
                          className={
                            "col_item " +
                            (appointment.is_deleted
                              ? "consultation-details-disabled"
                              : "")
                          }
                        >
                          {appointment?.cgst_percent == null ? (
                            0
                          ) : (
                            <span>
                              {appointment.cgst_percent}
                              {appointment.cgst_percent ? "%" : ""}
                            </span>
                          )}
                        </td>
                        <td
                          className={
                            "col_item " +
                            (appointment.is_deleted
                              ? "consultation-details-disabled"
                              : "")
                          }
                        >
                          {appointment?.sgst_percent == null ? (
                            0
                          ) : (
                            <span>
                              {appointment.sgst_percent}
                              {appointment.sgst_percent ? "%" : ""}
                            </span>
                          )}
                        </td>
                        <td
                          className={
                            "col_item total_amount_css " +
                            (appointment.is_deleted
                              ? "consultation-details-disabled"
                              : "")
                          }
                          style={{ minWidth: "92px" }}
                        >
                          <span>₹</span>
                          {appointment?.final_amount_in_rupees}
                        </td>
                        <td
                          className={
                            "col_item total_amount_css " +
                            (appointment.is_deleted
                              ? "consultation-details-disabled"
                              : "")
                          }
                        >
                          <span>₹</span>
                          {appointment?.paid_amount
                            ? appointment?.paid_amount
                            : 0}
                        </td>
                        <td
                          className={
                            "col_item total_amount_css " +
                            (appointment.is_deleted
                              ? "consultation-details-disabled"
                              : "")
                          }
                        >
                          <span>₹</span>
                          {appointment?.pending_amount
                            ? appointment?.pending_amount
                            : 0}
                        </td>
                      </tr>
                    ))}

                    {procedureDetailsState?.map((procedurePerRow, index) => {
                      if (procedurePerRow) {
                        return (
                          <tr
                            className="consultation-details-value-container"
                            key={index}
                          >
                            <td className="cd-table-checkbox-wrapper">
                              <CustomCheckbox
                                selected={
                                  procedurePerRow.isBulkDiscountCheckbox
                                }
                                isDisabled={
                                  procedurePerRow.isBulkDiscountCheckboxDisabled
                                }
                                handleOnSelect={() => {
                                  handleUpdateCheckBox("procedure", index);
                                }}
                              />
                            </td>
                            <td className="col_item consultion_heading_name">
                              <CustomSelect
                                className="select_style"
                                showSearch={true}
                                placeholder=""
                                value={getConsultationValue(procedurePerRow)}
                                options={consultationOptions}
                                handleChange={(opt) =>
                                  handleConsultationType(opt, index)
                                }
                                fixedBottomBtn={false}
                                isSearchable={false}
                                isDisabled={procedurePerRow.is_deleted}
                              />
                            </td>
                            <td
                              className={
                                "col_item " +
                                (procedurePerRow.is_deleted
                                  ? "consultation-details-disabled"
                                  : "")
                              }
                            >
                              {procedurePerRow.consultation_name === "" ? (
                                0
                              ) : (
                                <input
                                  type="tell"
                                  min="0"
                                  max="100"
                                  onKeyPress={(event) => {
                                    if (!/\d/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  className="discount_input"
                                  column={index + 1}
                                  value={procedurePerRow.fee_in_rupees}
                                  index={index}
                                  placeholder="0"
                                  onChange={(e) => applyFee(e, index)}
                                  autoComplete="off"
                                  disabled={procedurePerRow.is_deleted}
                                />
                              )}
                            </td>
                            <td
                              className={
                                "col_item " +
                                (procedurePerRow.is_deleted
                                  ? "consultation-details-disabled"
                                  : "")
                              }
                              style={{ minWidth: "90px" }}
                            >
                              {procedurePerRow?.partial_with_convenience_fee ??
                                0}
                            </td>
                            <td
                              className={
                                "col_item " +
                                (procedurePerRow.is_deleted
                                  ? "consultation-details-disabled"
                                  : "")
                              }
                              style={{ minWidth: "70px" }}
                            >
                              <span>₹</span>
                              {procedurePerRow.subtotal_in_rupees
                                ? procedurePerRow.subtotal_in_rupees
                                : 0}
                            </td>
                            <td
                              className={
                                "col_item " +
                                (procedurePerRow.is_deleted
                                  ? "consultation-details-disabled"
                                  : "")
                              }
                              key={index}
                              style={{ minWidth: "122px" }}
                            >
                              {procedurePerRow.consultation_name === "" ? (
                                <div className="cdp-discount-amt-wrapper">
                                  <span> 0 </span>
                                  <span> 0 </span>
                                </div>
                              ) : (
                                <div className="cd-discount-amt-wrapper">
                                  {displayProcedureRowDiscountPercentageInput(
                                    procedurePerRow,
                                    index
                                  )}
                                  {procedurePerRow.discount_percent > 0 && (
                                    <span className="cd-discount-or-text">
                                      or
                                    </span>
                                  )}
                                  {displayProcedureRowDiscountAmountInput(
                                    procedurePerRow,
                                    index
                                  )}
                                </div>
                              )}
                            </td>
                            <td
                              className={
                                "col_item " +
                                (procedurePerRow.is_deleted
                                  ? "consultation-details-disabled"
                                  : "")
                              }
                            >
                              {procedurePerRow.consultation_name === "" ? (
                                0
                              ) : (
                                <input
                                  type="tell"
                                  min="0"
                                  max="100"
                                  onKeyPress={(event) => {
                                    if (!/\d/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  className="discount_input"
                                  column={index + 1}
                                  value={
                                    procedurePerRow?.refund_in_rupees == null
                                      ? 0
                                      : procedurePerRow.refund_in_rupees
                                  }
                                  index={index}
                                  placeholder="0"
                                  onChange={(e) => applyRefund(e, index)}
                                  autoComplete="off"
                                  disabled={procedurePerRow.is_deleted}
                                />
                              )}
                            </td>
                            <td
                              className={
                                "col_item " +
                                (procedurePerRow.is_deleted
                                  ? "consultation-details-disabled"
                                  : "")
                              }
                            >
                              {procedurePerRow.igst_percent}
                              {procedurePerRow.igst_percent &&
                              procedurePerRow.igst_percent !== 0 ? (
                                <span>%</span>
                              ) : null}
                            </td>
                            <td
                              className={
                                "col_item " +
                                (procedurePerRow.is_deleted
                                  ? "consultation-details-disabled"
                                  : "")
                              }
                            >
                              {procedurePerRow.cgst_percent}
                              {procedurePerRow.cgst_percent &&
                              procedurePerRow.cgst_percent !== 0 ? (
                                <span>%</span>
                              ) : null}
                            </td>
                            <td
                              className={
                                "col_item " +
                                (procedurePerRow.is_deleted
                                  ? "consultation-details-disabled"
                                  : "")
                              }
                            >
                              {procedurePerRow.sgst_percent}
                              {procedurePerRow.sgst_percent &&
                              procedurePerRow.sgst_percent !== 0 ? (
                                <span>%</span>
                              ) : null}
                            </td>
                            <td
                              className="col_item total_amount_css"
                              style={{ minWidth: "92px", maxWidth: "92px" }}
                            >
                              <span
                                style={{ flex: "1" }}
                                className={
                                  "total-amount " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                <span>₹</span>
                                {procedurePerRow.final_amount_in_rupees
                                  ? procedurePerRow.final_amount_in_rupees
                                  : 0}
                              </span>
                            </td>
                            <td className="col_item total_amount_css">
                              <span>₹</span>
                              {procedurePerRow?.paid_amount
                                ? procedurePerRow?.paid_amount
                                : 0}
                            </td>
                            <td className="col_item total_amount_css">
                              <div style={{ display: "flex", width: "80px" }}>
                                <span>₹</span>
                                <span>
                                  {procedurePerRow?.pending_amount
                                    ? procedurePerRow?.pending_amount
                                    : 0}
                                </span>
                                {!procedurePerRow.is_deleted && (
                                  <span style={{ marginLeft: "auto" }}>
                                    <img
                                      onClick={() => deleteProcedure(index)}
                                      src={DeleteIcon}
                                      alt=""
                                      style={{
                                        minWidth: "16px",
                                        marginLeft: "10px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </span>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      }
                    })}
                  </tbody>
                </table>
                <div className="add-procedure-wrapper">
                  <span className="add-procedure-btn" onClick={addNewProcedure}>
                    + Add Procedure
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>{isMobile ? consulationDetailsUI() : consultationDetailsTableUI()}</>
  );
};

export default ConsultationDetails;
